import { render, staticRenderFns } from "./ArtworkApprovals.vue?vue&type=template&id=0b4621c4"
import script from "./ArtworkApprovals.vue?vue&type=script&lang=js"
export * from "./ArtworkApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports